import React from 'react';
import SectionTitle from '../../content/SectionTitle';
import AddressSummary from '../../summary/AddressSummary';
import { CustomerBillingAddressContract } from '../../../types/Customer';
import { AddressFormData } from '../../../types/Address';
import InternalLink from '../InternalLink';
import LabeledRadioButton from '../LabeledRadioButton';
import { GroupNames } from '../../../utils/constants';

export const AddressListTestId = 'AddressList-input';
export const AddressListItemTestId = 'AddressListItem-input';

export type AddressListItemProps = {
  address: CustomerBillingAddressContract;
  selectedAddressId?: number | null;
  groupName: string;
  onAddressSelected: (addressId: number) => void;
};

export const AddressListItem: React.FC<AddressListItemProps> = ({
  address,
  selectedAddressId,
  groupName,
  onAddressSelected,
}: AddressListItemProps) => {
  const handleAddressSelected = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    onAddressSelected?.(Number.parseInt(event.target.value, 10));
  };

  return (
    <li className="flex flex-row" data-testid={AddressListTestId}>
      <LabeledRadioButton
        label=""
        value={(address.id as number).toString()}
        name={groupName}
        defaultChecked={address.id === selectedAddressId}
        onChange={handleAddressSelected}
      >
        <AddressSummary address={address as AddressFormData} />
      </LabeledRadioButton>
    </li>
  );
};

export type AddressListProps = {
  addresses: Array<CustomerBillingAddressContract>;
  title: string;
  subTitle?: string;
  addActionText: string;
  selectedAddressId?: number | null;
  onAddActionClicked: () => void;
  onCancel: () => void;
  onAddressSelected: (addressId: number) => void;
};

const AddressList: React.FC<AddressListProps> = ({
  addresses,
  title,
  subTitle,
  addActionText,
  onAddActionClicked,
  onAddressSelected,
  onCancel,
  selectedAddressId,
}: AddressListProps) => {
  return (
    <div
      className="flex flex-col mx-2 space-y-2 min-h-1/2"
      data-testid={AddressListTestId}
    >
      <div className="text-xs">
        <InternalLink onClick={onCancel}>Go back</InternalLink>
      </div>
      <SectionTitle>{title}</SectionTitle>
      {subTitle && <div className="mx-2 mb-2 text-sm">{subTitle}</div>}
      <ul className="flex flex-col border checkout-panel-border rounded-md divide divide-y">
        {addresses.map(address => (
          <AddressListItem
            key={address.id}
            address={address}
            groupName={GroupNames.SHIPPING_ADDRESS_GROUP_NAME}
            selectedAddressId={selectedAddressId || addresses[0].id}
            onAddressSelected={onAddressSelected}
          />
        ))}
      </ul>
      <InternalLink className="text-left" onClick={onAddActionClicked}>
        {addActionText}
      </InternalLink>
    </div>
  );
};

export default AddressList;
